$(document).ready(function() {
    var topswiper = new Swiper('.product-slider', {
        slidesPerView: 4,
        loop: 'true',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 14,
        breakpoints: {
            // when window width is <= 320px
            320: {
                slidesPerView: 2,
                spaceBetweenSlides: 10
            },
            // when window width is <= 480px
            480: {
                slidesPerView: 2,
                spaceBetweenSlides: 15
            },
            // when window width is <= 640px
            768: {
                slidesPerView: 3,
                spaceBetweenSlides: 15
            }
        }
    });
    var aboutswiper = new Swiper('#about-swiper', {
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        loop: true,
        spaceBetween: 25,
        slidesPerView: 1,
        breakpoints: {
            767: {
                slidesPerView: 1
            },
            1023: {
                slidesPerView: 1
            }
        }
    });


    $('.search-toggle').click(function(event) {
        event.preventDefault();
        $(this).toggleClass('active');
        $('.mobilesearch').stop(true, true).slideToggle('slow');
        $('.mobilesearch').toggleClass('open');
        // $('.search-toggle i').toggleClass('fa-search');
        // $('.search-toggle i').toggleClass('fa-close');
        if ($('.mobilesearch').hasClass('open')) {
            $('#LiveSearchmobile').focus();
        } else {
            $('#LiveSearchmobile').focusout();
        }
    });
    var homeSwiper = new Swiper('#home-swiper', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        loop: true,
        autoplay: 4000,
        speed: 2000,
        effect: 'fade',
        fade: {
            crossFade: true
        }
    });

    $('.producer-list .PlentyItemProducerListItem').each(function() {
        $('.brand-swiper .swiper-wrapper').append('<div class="swiper-slide">' + $(this).html() + '</div>');
    })

    var brandSwiper = new Swiper('.brand-swiper', {
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 5,
        spaceBetween: 15,
        lazyLoading: 'true',
        breakpoints: {
            768: {
                slidesPerView: 3
            }
        }
    });
    $('.main-nav li.dropdown').hover(function() {
        var brandSwiper = new Swiper('.brand-swiper-2', {
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            loop: true,
            slidesPerView: 4,
            spaceBetween: 70,
            breakpoints: {
                768: {
                    slidesPerView: 3
                }
            }
        });
    }, function() {
        /* Stuff to do when the mouse leaves the element */
    });
    $('.category-swiper').each(function() {
        if ($(this).length > 4) {
            var countSlide = true;
        } else {
            var countSlide = false;
        }

        var categoryswiper = new Swiper($(this), {
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            loop: countSlide ? true : false,
            spaceBetween: 25,
            slidesPerView: 4,
            breakpoints: {
                767: {
                    slidesPerView: 2
                },
                1023: {
                    slidesPerView: 3
                }
            }
        })
    });

    if (homeSwiper.classNames.length != 0) {
        homeSwiper.on('SlideNextStart', function(item) {
            $('#home-swiper .img-left').each(function() {
                $(this).removeClass('slideOutLeft');
                $(this).removeClass('animated');
            })
            $('#home-swiper .slide-right').each(function() {
                $(this).removeClass('slideOutRight');
                $(this).removeClass('animated');
            })
            var index = item.activeIndex;
            var slide = $('#home-swiper .swiper-slide:nth-child(' + index + ')');
            slide.find('.img-left').addClass('animated slideOutLeft');
            slide.find('.slide-right').addClass('animated slideOutRight');
        });
        homeSwiper.on('SlidePrevStart', function(item) {
            $('#home-swiper .img-left').each(function() {
                $(this).removeClass('slideOutLeft');
                $(this).removeClass('animated');
            })
            $('#home-swiper .slide-right').each(function() {
                $(this).removeClass('slideOutRight');
                $(this).removeClass('animated');
            })
            var index = item.activeIndex + 2;
            var slide = $('#home-swiper .swiper-slide:nth-child(' + index + ')');
            slide.find('.img-left').addClass('animated slideOutLeft');
            slide.find('.slide-right').addClass('animated slideOutRight');
        });
    }
    var clicky;
    $(document).mousedown(function(e) {
        clicky = $(e.target);
    });
    $(document).mouseup(function(e) {
        clicky = null;
    });

    $('#LiveSearch').focusout(function(event) {
        if (!$(clicky).hasClass('search-toggle-desktop') && !$(clicky).parents('.search-toggle-desktop').length) {
            if ($('#LiveSearch').val().length < 1) {
                $(".desktopsearch").removeClass('active');
                $(".search-toggle-desktop").removeClass('btn btn-primary');
            }
        }
    });

    // UNVEIL
    $("img").unveil(200, function() {
        $(this).load(function() {
            var classes = this.getAttribute('class');
            this.setAttribute("class", classes + ' loaded');
        });
    });

    //Livesearch
    $('#LiveSearch').keyup(function(event) {
        if ($(this).val().length >= 1) {
            $('.desktopsearch').addClass('hasval');
        } else {
            $('.desktopsearch').removeClass('hasval');
        }
        if (this.value.length < 2) {
            $('#livesearch_result').hide();

        } else {
            $('#livesearch_result').show();
            var data = '';
            jQuery.ajax({
                url: '/WebAjaxBase.php?Object=article@LiveArticleSearch&SearchParam=' + encodeURIComponent($(this).val()),
                type: "post",
                dataType: "html",
                error: function(XMLHttpRequest, textStatus, errorThrown) {
                    if (typeof(window.console) != "undefined") {
                        window.console.log(XMLHttpRequest)
                    }
                },
                success: function(html) {


                    var count = 0;
                    if ($(html).find('.LiveSearchNoArticleFoundHint').length) {
                        data += "<h5>Leider wurde zu Ihrer Suchanfrage kein passendes Ergebnis gefunden.</h5>";
                        result = false;
                    } else {
                        //search in each tabelrow
                        $(html).find('tr').each(function() {
                            if (count == 0) {
                                data += "<h3>Suchergebnisse:</h3>";
                            } else if (count <= 5) {
                                //Holt Artikelbild und Entfernt inlinestyles
                                var img = $(this).find('.LiveSearchImage').find('img').attr('style', '').addClass('img-responsive').parent().html();
                                //Platzhalter falls kein Bild vorhanden
                                if (typeof img == "undefined") {
                                    img = '<i class="fa fa-picture-o" aria-hidden="true"></i>';
                                }
                                //verlinkt Bild
                                var link = $(this).find('.LiveSearchArticleName a').attr('href');

                                //Holt Artikel Name
                                var title = $(this).find('.LiveSearchArticleName').html();
                                //HTML Ausgabe bauen

                                data += '<div class="row mt-xs-20 search-products"><div class="col-xs-2"><a href="' + link + '">' + img + '</a></div><div class="col-xs-10 link">' + title + '</div></div>';
                            }
                            count++;
                            //first=false;
                        });
                        result = true;
                    }
                },

                complete: function(html) {
                    $('#livesearch_result').empty();
                    $('#livesearch_result').append(data);
                    //catch empty results and redirekt to custom page

                    //set custom button under result list
                    if (result) {
                        $('#livesearch_result').append('<div class="text-center mt-xs-25"><a id="showall" class="btn btn-default btn-block">Alle anzeigen</a></div>');
                        $('#livesearch_result').find('#showall').click(function(e) {
                            e.preventDefault();
                            $('#LiveSearch').closest('form').submit();
                        });
                    }

                }
            })
        }
    });
})
$(window).resize(function(event) {
    $("img").unveil();
});
$(".btn-filter").click(function() {
    $('.filter-wrap').toggle("normal");
});
$(window).resize(function() {
    if ($(window).width() > 992) {
        $('.filter-wrap').show();
        $('.filter-wrap .panel-collapse').removeClass('in');
    }
});
$(document).ready(function() {
    // var posTop = $('#scroll-up').offset().top;
    $(window).scroll(function() {
        var threshold = 150;
        if ($(window).scrollTop() >= threshold)
            $('#scroll-up').addClass('fixed');
        else
            $('#scroll-up').removeClass('fixed');
        var check = $('.stop-scroll').offset().top - $(window).height() + $("#scroll-up").height() - 21;
        if ($(window).scrollTop() >= check) {
            $('#scroll-up').addClass('bottom');
            $('#scroll-up').css('top', $(".main-frame").height() - $("#scroll-up").height() + $('.header').height() - 40);
        } else {
            $('#scroll-up').removeClass('bottom');
            $('#scroll-up').css('top', "");
        }
    });
    $(window).scroll(function() {
        var threshold = 400;
        if ($(window).scrollTop() >= threshold) {
            $('.service-tab').addClass('fixed');
        } else {
            $('.service-tab').removeClass('fixed');
        }

    });
    $('#service-tab-close').click(function(event) {
        $('.service-tab').removeClass('open');
    });


    $('.service-tab button,.service-tab .service-box').mouseover(function(event) {
        $('.service-tab').addClass('open');
    }).mouseout(function(event) {
        $('.service-tab').removeClass('open');
    });


    $('#scroll-up').click(function(event) {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });

    $('.smooth-scroll').click(function(e) {
        e.preventDefault();
        var target = $(this).attr('href');
        $('html, body').animate({ scrollTop: $(target).offset().top }, 2000);
    });
    if ($(window).width() < 992) {
        $('.filter-wrap .panel-collapse').removeClass('in');
    }
    $('.product').each(function() {
        var product = $(this);
        var count = 0;
        if ($(this).find('.PlentyWebAttributeTitle:contains("Farbe")').length == 0) {
            $(this).removeClass('attribute-exist');
        }
        $(this).find('.PlentyWebAttributeTitle:contains("Farbe")').parent().find("option").each(function() {
            if (count < 8) {
                product.find('.attribute').append('<div class="attribute-color color-' + $(this).val() + '"></div>');
            }
            count++;
        })
    })

    $('#mobile_basket_preview .delete-preview-item').click(function() {
        setTimeout(function() {
            $.get("/rest/itemview/container_itemviewbasketpreviewlist/", function(data) {
                if (data.error.code == 0) {
                    console.log(data.data)
                    $('#mobile_basket_preview').html(data.data);
                }
            }, "json");
        }, 1000)
    })

});
